import React from "react";
import { DropdownButton, Alert, Button, Dropdown, Form, Container, Modal } from "react-bootstrap";
import { dealstages } from "../../components/CONSTANTS";
import { FormControl } from "react-bootstrap";
export const EditLeadAsAdminModal = ({ leadnumber, firstName, lastName, pandadocID, email, referenceadmin, loading }) => {

    const [show, setShow] = React.useState(false);
    const [dealStage, setDealStage] = React.useState("");

    const saveEditedLead = e => {

    }
    const handleDealstageSelect = (e) => {
        setDealStage(e);
    }

    return (
        <>
            <Button disabled={loading} onClick={() =>
                setShow(!show)
            } variant={"warning"}>
                Redigera Lead
            </Button>

            <Modal show={show}>
                <Modal.Header>
                    Redigera lead {leadnumber}
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={saveEditedLead}>
                        <Form.Group>
                            <Form.Label>Kund-email</Form.Label>
                            <FormControl type="email">
                            </FormControl>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Kund-namn</Form.Label>
                            <FormControl type="text">
                            </FormControl>
                        </Form.Group>
                        <Form.Group>

                            <DropdownButton
                                alignRight
                                title="Ange dealstage"
                                id="dropdown-menu-align-right"
                                onSelect={handleDealstageSelect}
                                style={{ margin: '5px' }}

                            >
                                <Dropdown.Item eventKey={dealstages.INKOMMENLEAD}>Inkommen Lead</Dropdown.Item>
                                <Dropdown.Item eventKey={dealstages.OFFERTSKAPAD}>Offert Skapad</Dropdown.Item>
                                <Dropdown.Item eventKey={dealstages.OFFERTSKICKAD}>Offert Skickad</Dropdown.Item>
                                <Dropdown.Item eventKey={dealstages.OFFERTSEDD}>Offert Sedd</Dropdown.Item>
                                <Dropdown.Item eventKey={dealstages.OFFERTNEKAD}>Offert Nekad</Dropdown.Item>
                                <Dropdown.Item eventKey={dealstages.OFFERTGODKAND}>Offert Godkänd</Dropdown.Item>
                            </DropdownButton>

                            {dealStage ?
                                <label>
                                    {dealStage}

                                </label> : <label>Ange dealstage</label>}
                        </Form.Group>
                    </Form>
                    <Button variant="primary" onClick={() => setShow(false)}>
                        Stäng
                    </Button>
                    <Button variant="success" onSubmit={() => saveEditedLead()}>
                        Spara Ändringar
                    </Button>
                </Modal.Body>
            </Modal>
        </>
    )
}